<template>
  <div class="assign-table">
    <div class="left-table">
      <div class="mt-20 flex flex-v-center ">
        <el-select
          v-model="category_type"
          placeholder="Select"
          class="inline-select"
          @change="changeCategory()"
        >
          <el-option
            v-for="item in orgMenu"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <div class="ml-10" v-if="!showSearch">
          <el-select
            v-model="selectedDepartment"
            placeholder="Select Department"
            class="inline-select"
            v-if="category_type === 'department'"
            @change="getEmployeesByDepartment()"
            multiple
          >
            <el-option
              v-for="item in departments"
              :key="item.id"
              :label="item.department_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="selectedGrade"
            placeholder="Select Grade"
            class="inline-select"
            v-if="category_type === 'grade'"
            @change="getEmployeesByGrade()"
            multiple
          >
            <el-option
              v-for="item in grades"
              :key="item.id"
              :label="item.grade_name"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <el-select
            v-model="selectedBranch"
            placeholder="Select Branch"
            class="inline-select"
            v-if="category_type === 'branch'"
            @change="getEmployeesByBranch()"
            multiple
          >
            <el-option
              v-for="item in branches"
              :key="item.id"
              :label="item.station_name"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <el-select
            v-model="selectedTeam"
            placeholder="Select Team"
            class="inline-select"
            v-if="category_type === 'team'"
            @change="getEmployeesByTeam()"
            multiple
          >
            <el-option
              v-for="item in teams"
              :key="item.id"
              :label="item.team_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="ml-10">
          <div class="pointer" @click="showSearch = !showSearch">
            <img
              src="/img/search-icon.svg"
              alt=""
              v-if="category_type !== 'employee' && !showSearch"
            />
          </div>

          <div
            class="relative"
            v-if="category_type === 'employee' || showSearch"
          >
            <img
              src="/img/search-icon.svg"
              alt="search"
              class="search-icon pointer"
              @click="showSearch = !showSearch"
            />
            <el-input
              placeholder="Search"
              name="search"
              type="text"
              class="short mr-10"
              v-model="searchQuery"
              @input="search"
              clearable
              @clear="showSearch = !showSearch"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="flex flex-v-center mt-40 mb-20">
        <p class="sub-head">List of Employees</p>
        <span class="success ml-10 small-text"
          >{{ employeeListTotal && employeeListTotal }} Found</span
        >
      </div>

      <div class="table">
        <el-table
          :data="employeeList"
          @selection-change="handleSelectionChangeEmployeeList"
          empty-text=""
          v-loading="loading"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="pin" label="PIN" width="120"></el-table-column>
          <el-table-column
            prop="name"
            label="Employee's Name"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="department"
            label="Department"
            width="120"
            :formatter="tableFormatter"
          ></el-table-column>
        </el-table>
        <div class="pagination-container" v-if="!loading">
          <el-pagination
            mini
            @size-change="handleSizeChangeEmployeeList"
            @current-change="handleCurrentChangeEmployeeList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="perPageEmployeeList"
            layout="total, sizes, prev, pager, next, jumper"
            :total="employeeListTotal"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="flex flex-column transfer">
      <div class="mb-20 pointer" @click="transfer">
        <img
          v-if="multipleSelectionList.length"
          src="/img/transfer-to-b.svg"
          alt="&#62;"
        />
        <img v-else src="/img/transfer-to-w.svg" alt="&#62;" />
      </div>
      <div class="pointer" @click="remove">
        <img
          v-if="multipleSelectionSelected.length"
          src="/img/transfer-back-b.svg"
          alt="&#60;"
        />
        <img v-else src="/img/transfer-back-w.svg" alt="&#60;" />
      </div>
    </div>
    <div class="right-table">
      <div class="flex flex-v-center mb-20">
        <p class="sub-head">Selected Employees</p>
        <span class="success ml-10 small-text"
          >{{
            payload.assignedEmployees && payload.assignedEmployees.length
          }}
          Selected</span
        >
      </div>
      <div class="table">
        <el-table
          :data="payload.assignedEmployees"
          @selection-change="handleSelectionChangeEmployeeSelected"
          empty-text=""
          style="width: 100%"
          height="350"
          v-loading="loading"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="pin" label="PIN" width="80"></el-table-column>
          <el-table-column
            prop="name"
            label="Employee's Name"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="department"
            label="Department"
            :formatter="tableFormatter"
            width="120"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import AssignEmployeeMixin from "../Mixins/AssignEmployeeMixin";

export default {
  data() {
    return {
      showSearch: false,
    };
  },
  mixins: [AssignEmployeeMixin],
  methods: {
    assign() {
      const inputData = {
        category_type: this.category_type,
        assign_category_type_ids: this.employeeSelected.map(x => x.id),
        unassign_category_type_ids: this.unassignEmployee.map(x => x.id),
      };
      this.$emit("assign", inputData);
    },
  },
};
</script>

<style scoped>
.el-select.inline-select {
  width: 200px !important;
}

.search-icon {
  position: absolute;
  z-index: 1;
  top: 11px;
  left: 1px;
}

.sub-head {
  font-size: 16px;
  font-weight: bold;
}

.btn-right {
  outline: none;
  padding: 10px;
  margin: 10px;
  text-decoration: none;
  border: 1px solid var(--blue);
  background-color: #fff;
  color: var(--blue);
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
}

/* ...existing styles... */

.assign-table {
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
  overflow: scroll;
}

.left-table,
.right-table {
  flex: 1 1 350px;
  min-width: 300px;
  box-sizing: border-box;
}

.right-table {
  margin-top: 100px;
  padding-left: 20px;
}

.transfer {
  padding-top: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

@media (max-width: 1100px) {
  .assign-table {
    flex-direction: column;
    align-items: stretch;
  }
  .right-table {
    margin-top: 40px;
    padding-left: 0;
  }
  .transfer {
    flex-direction: row;
    padding-top: 20px;
    justify-content: center;
    margin-bottom: 20px;
  }
}

@media (max-width: 600px) {
  .left-table,
  .right-table {
    min-width: 100%;
    padding: 0;
  }
  .assign-table {
    padding: 0 5px;
  }
  .sub-head {
    font-size: 14px;
  }
  .el-select.inline-select {
    width: 100% !important;
    min-width: 0;
  }
}
</style>
